import { render, staticRenderFns } from "./ServiceSlotsView.vue?vue&type=template&id=04c849fc"
import script from "./ServiceSlotsView.vue?vue&type=script&lang=js"
export * from "./ServiceSlotsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports